import { axiosObject } from '../setup';
import baseValidator from '../baseValidator';

function requestOTPForVerification(payload) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_AUTH_API_URL}/request-verify`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          reject(errors.response.data.errors);
        }
        reject(errors);
      });
  });
}

const constraints = {
  otp: {
    presence: {
      allowEmpty: false,
      message: '^Please enter your otp',
    },
    length: {
      minimum: 6,
      message: '^Invalid OTP. Please enter again',
    },
  },
};

function verifyOTPForVerification(payload) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_AUTH_API_URL}/do-verify`;

    var jsValidationErrors;

    jsValidationErrors = baseValidator(payload, constraints);

    if (jsValidationErrors === true) {
      axiosObject
        .post(uri, payload)
        .then((response) => {
          resolve(payload);
        })
        .catch((errors) => {
          if (errors.response.status === 422) {
            reject(errors.response.data.errors);
          }
          reject(errors);
        });
    } else {
      reject(jsValidationErrors);
    }
  });
}

export { requestOTPForVerification, verifyOTPForVerification };
